<template>
  <div class="graphs">
    <div class="c1">
      <Chart></Chart>
    </div>
  </div>
</template>

<script>
import Chart from "./Chart";
import {mapMutations} from "vuex";
export default {
name: "History",
  components: {Chart},
  methods: {
    ...mapMutations([
      'setSelectedPatient'
    ])
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/History.vue